import { createMigrate, type PersistedState } from 'redux-persist'

import { prodToV1 } from './prodToV1'

const migrations = {
  1: (state: PersistedState) => state,
}

const migrateVersions = createMigrate(migrations, { debug: false })

export const CLIPBOARD_PERSIST_VERSION = 1

export const clipboardMigrate = (state: PersistedState, version: number) => {
  if (state) return migrateVersions(state, version)

  const cards = prodToV1()
  if (!cards) return Promise.resolve(undefined)

  return migrateVersions({ _persist: { rehydrated: false, version: 1 }, cards } as unknown as PersistedState, version)
}
